// Device-registration-code helpers shared by the registration MainForm and the
// BDE audit screen. Single source of truth so the client-side normalisation stays
// identical in both flows and matches the backend (apps.bde.device_code and the
// registration validators): strip every non-alphanumeric character and upper-case,
// with a 15/16-char length gate (15 = DES EVO code, 16 = legacy code).

// v-maska mask for the device-code field: 15-char DES EVO codes group by 5,
// 16-char legacy codes group by 4.
export const DEVICE_REGISTRATION_CODE_MASK = ['XXXXX XXXXX XXXXX', 'XXXX XXXX XXXX XXXX']

// The two accepted device-code lengths (15 = DES EVO, 16 = legacy).
export function isValidDeviceCodeLength(code) {
  return code.length === 15 || code.length === 16
}

export function normalizeDeviceCode(raw) {
  if (!raw || typeof raw !== 'string') return ''
  return raw.replace(/[^0-9A-Za-z]/g, '').toUpperCase()
}

export function extractDeviceCodeFromQr(raw) {
  if (!raw || typeof raw !== 'string') return ''
  const trimmed = raw.trim()
  // Старі 16-знакові пристрої кодують код як URL: https://device.ploom.com/?s=<CODE>
  try {
    const u = new URL(trimmed)
    for (const key of ['s', 'code', 'serial']) {
      const v = u.searchParams.get(key)
      if (v) {
        const norm = normalizeDeviceCode(v)
        if (norm.length === 15 || norm.length === 16) return norm
      }
    }
  } catch (_) { /* not a URL */ }
  // Толерантний fallback: знаходимо 15- або 16-символьну послідовність [0-9A-Z] всередині рядка.
  // Строгіша перевірка лівого кордону (через ручний i-1, а не lookbehind): відсікаємо
  // випадки, коли 15-16 символів — хвіст довшого alphanumeric run, що випадково підпав
  // під довжину коду.
  const upper = trimmed.toUpperCase()
  const re = /[0-9A-Z]{15,16}(?![0-9A-Z])/g
  let m
  while ((m = re.exec(upper)) !== null) {
    const i = m.index
    if (i === 0 || !/[0-9A-Z]/.test(upper[i - 1])) return m[0]
  }
  return normalizeDeviceCode(trimmed)
}

export function formatDeviceCode(value) {
  const clean = normalizeDeviceCode(value)
  const groupSize = clean.length === 16 ? 4 : 5
  const re = new RegExp(`.{1,${groupSize}}`, 'g')
  return clean.match(re)?.join(' ') || clean
}
